<div class="panel-shell">
  <header class="panel-header">
    <div class="panel-title text-bold">
      {{ "PHOTO_LIBRARY_PANEL.TITLE" | translate }}
    </div>
    <div class="panel-header-actions flex-row-center-center">
      <button
        mat-icon-button
        type="button"
        class="panel-close-btn"
        (click)="close()"
        aria-label="Close panel"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </header>

  <div class="panel-body">
    <!-- Onglets : Ma bibliothèque / Bibliothèque GT (masqués si module absent) -->
    <div class="lib-tabs flex-row-start-center">
      <button
        *ngIf="modulesService.hasMyPhotoLib()"
        mat-button
        class="lib-tab"
        [class.lib-tab-active]="activeTab === 'mine'"
        (click)="selectTab('mine')"
      >
        {{ "PHOTO_LIBRARY_PANEL.TAB_MINE" | translate }}
      </button>
      <button
        *ngIf="modulesService.hasGtPhotoLib()"
        mat-button
        class="lib-tab"
        [class.lib-tab-active]="activeTab === 'gt'"
        (click)="selectTab('gt')"
      >
        {{ "PHOTO_LIBRARY_PANEL.TAB_GT" | translate }}
      </button>
    </div>

    <mat-form-field class="search-field" floatLabel="auto" subscriptSizing="dynamic">
      <mat-label>{{ "PHOTO_LIBRARY_PANEL.SEARCH" | translate }}</mat-label>
      <mat-icon matPrefix class="search-icon">search</mat-icon>
      <input matInput [(ngModel)]="filterValue" autocomplete="off" />
      <button
        mat-icon-button
        *ngIf="filterValue"
        matSuffix
        type="button"
        aria-label="Clear"
        (click)="clearSearch()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <div class="lib-results">
      <div *ngIf="isLoading" class="lib-state">
        <mat-spinner [diameter]="32"></mat-spinner>
      </div>

      <div
        *ngIf="!isLoading && filteredItems.length === 0"
        class="lib-state empty-message"
      >
        <mat-icon class="empty-icon">image_search</mat-icon>
        <div>{{ "PHOTO_LIBRARY_PANEL.EMPTY" | translate }}</div>
      </div>

      <div *ngIf="!isLoading && filteredItems.length > 0" class="photo-grid">
        @for (photo of filteredItems; track photo.key) {
          <div
            matRipple
            class="photo-card"
            [class.photo-card-selected]="isSelected(photo)"
            (click)="onSelect(photo)"
          >
            <div class="photo-thumb">
              <img
                [src]="photo.thumbUrl"
                [alt]="photo.label"
                onerror="if (this.src !== '/assets/images/logos/fuse.png') {this.src='/assets/images/logos/fuse.png'}"
              />
              <div class="photo-check" *ngIf="isSelected(photo)">
                <mat-icon>check</mat-icon>
              </div>
            </div>
            <div class="photo-label" *ngIf="photo.label" [matTooltip]="photo.label">
              {{ photo.label }}
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <footer class="panel-footer flex-row-center-center">
    <button mat-stroked-button (click)="close()" class="mr-8" [disabled]="isSaving">
      {{ "GENERIC.CANCEL" | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="onAdd()"
      [disabled]="selected === null || isSaving"
    >
      <span *ngIf="!isSaving">{{ "PHOTO_LIBRARY_PANEL.ADD" | translate }}</span>
      <mat-spinner *ngIf="isSaving" [diameter]="20"></mat-spinner>
    </button>
  </footer>
</div>
